/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as baseActions from './actions.base';
@Injectable()
export class BaseEffect implements OnInitEffects {
  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {}

  ngrxOnInitEffects(): Action {
    this.store.dispatch(baseActions.translationActions.getTranslation());
    this.store.dispatch(baseActions.systemSettingsActions.getSystemSettings());
    return baseActions.systemLookupActions.getSystemLookups();
  }

  getSystemLookups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(baseActions.systemLookupActions.getSystemLookups),
      switchMap(() => of('')),
      map(response =>
        baseActions.systemLookupActions.getSystemLookupsSuccess({ response }),
      ),
      catchError((error: any) =>
        of(baseActions.systemLookupActions.getSystemLookupsFailure({ error })),
      ),
    ),
  );
}
